<svelte:head>
  <title>Company | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-label-has-associated-control -->

<article class="message is-info">
  <div class="message-body">
    Your business details are only shared with charities that you select for
    your offers.
  </div>
</article>

<!-- form -->

<!-- apply? -->

<!-- toast to show saved -->

{#if showToast}
  <div class="notification is-success">
    <button class="delete" on:click={() => (showToast = false)} />
    Details saved.
  </div>
{/if}

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="name" class="label">Business name</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input
          id="name"
          class="input"
          type="text"
          placeholder=""
          bind:value={data.name} />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="website" class="label">Website</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input
          id="website"
          class="input"
          type="text"
          placeholder=""
          bind:value={data.website} />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="addressline1" class="label">Address</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input
          for="addressline1"
          class="input"
          type="text"
          placeholder="Address line 1"
          bind:value={data.address.addressline1} />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="addressline2" class="label" />
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input
          id="addressline1"
          class="input"
          type="text"
          placeholder="Address line 2"
          bind:value={data.address.addressline2} />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="town" class="label" />
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input
          id="town"
          class="input"
          type="text"
          placeholder="Town"
          bind:value={data.address.posttown} />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="postcode" class="label" />
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input
          id="postcode"
          class="input"
          type="text"
          placeholder="Postcode"
          bind:value={data.address.postcode} />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label">
    <!-- Left empty for spacing -->
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <button
          class="button is-primary"
          class:is-loading={isLoading}
          on:click={save}>Save</button>
      </div>
    </div>
  </div>
</div>

{#if errorMessage}
  <div class="block">
    <div class="notification is-danger is-light">
      {errorMessage}
    </div>
  </div>
{/if}

<script lang="ts">
  import _ from 'lodash';
  import { logging } from '../../../lib/logging';
  import { appState } from '../../../lib/appState';

  let data = _.cloneDeep($appState.company) as Company_v1;

  let showToast = false;
  let errorMessage: string;
  let isLoading = false;

  let firebase = window.firebase;

  async function save() {
    isLoading = true;

    data.postcode = data.address.postcode;

    try {
      let result = await firebase.functions().httpsCallable('api-account-updatecompany')({
        id: $appState.user!.company,
        company: data
      } as UpdateCompanyParams);

      $appState.company = result.data.company;

      showToast = true;
    } catch (err: any) {
      logging.report(err.toString());
      errorMessage = err.toString();
    }
    isLoading = false;
  }
</script>
